// Profile completion gate strings — EN + TR.
//
// Used by `features/onboarding/ProfileCompletionGate.tsx` (blocking modal that
// collects a missing name / phone). The KVKK notice title comes from the
// backend; only the sentence around it lives here.

import type { LocalizedDict } from '../index'

type ProfileCompletionStrings = {
  title: string
  intro: string
  nameLabel: string
  phoneLabel: string
  nameRequired: string
  phoneRequired: string
  saveFailed: string
  kvkkBefore: string
  kvkkAfter: string
  saving: string
  submit: string
}

export const profileCompletionI18n: LocalizedDict<ProfileCompletionStrings> = {
  en: {
    title: 'Complete your profile',
    intro:
      'Please complete the fields below so we can verify your account and run our service processes smoothly.',
    nameLabel: 'Full name',
    phoneLabel: 'Phone number',
    nameRequired: 'Full name is required.',
    phoneRequired: 'Phone number is required.',
    saveFailed: 'Could not save, please retry.',
    kvkkBefore: 'This information is processed under the ',
    kvkkAfter: ' for the purpose of running our service processes.',
    saving: 'Saving…',
    submit: 'Save and continue',
  },
  tr: {
    title: 'Profil Bilgilerinizi Tamamlayın',
    intro:
      'Hesap doğrulama ve hizmet süreçlerinin sağlıklı yürütülebilmesi için lütfen aşağıdaki bilgileri eksiksiz doldurunuz.',
    nameLabel: 'Ad Soyad',
    phoneLabel: 'Telefon Numarası',
    nameRequired: 'Ad Soyad gerekli.',
    phoneRequired: 'Telefon numarası gerekli.',
    saveFailed: 'Kaydedilemedi, lütfen tekrar deneyin.',
    kvkkBefore: 'Bu bilgiler ',
    kvkkAfter: ' kapsamında ve hizmet süreçlerinin yürütülmesi amacıyla işlenmektedir.',
    saving: 'Kaydediliyor…',
    submit: 'Kaydet ve Devam Et',
  },
}
